import React from 'react';
import { Menu as RAMenu, DashboardMenuItem, /*MenuItemLink,*/ useResourceDefinitions, useTranslate, useSidebarState } from 'react-admin';
import { Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import MUIIconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import AddIcon from '@mui/icons-material/Add';
import AddCircleIcon from '@mui/icons-material/AddCircle';
// import WarningAmberIcon from '@mui/icons-material/WarningAmber';
// import DownloadIcon from '@mui/icons-material/Download';
import preval from 'preval.macro';
import moment from 'moment';

import IconButton from './common/buttons/IconButton';

const Menu = (props) => {
	const resourcesDefinitions = useResourceDefinitions();
	const resources = Object.keys(resourcesDefinitions).map(name => resourcesDefinitions[name]);
	const [open] = useSidebarState();
	const translate = useTranslate();

	if (resources.length <= 0) {
		return null;
	}

	const getBuildDate = () => {
		const buildDate = moment(preval`module.exports = new Date();`);
		const now = moment.now();
		return moment.duration(buildDate - now).humanize(true);
	};

	return (
		<RAMenu {...props}>
			<DashboardMenuItem dense={false} />
			<RAMenu.ResourceItem name="events" />
			{/* <MenuItemLink to={`/support`} primaryText={translate('A problem?')} leftIcon={<WarningAmberIcon />} /> */}
			{/* <MenuItemLink to={`/marketing`} primaryText={translate('Marketing')} leftIcon={<DownloadIcon />} /> */}
			<Box sx={{ textAlign: 'center' }} my={5}>
				{open ? (
					<IconButton icon={<AddIcon />} component={Link} to={`/events/create`} variant="contained" color="secondary" sx={{ whiteSpace: 'nowrap' }}>{translate('Create event')}</IconButton>
				) : (
					<MUIIconButton color="secondary" component={Link} to={`/events/create`}>
						<AddCircleIcon />
					</MUIIconButton>
				)}
			</Box>
			<Typography variant="caption" className="build-date">build {getBuildDate()}</Typography>
		</RAMenu>
	);
};

export default Menu;
